'use client';

import { Controller } from 'react-hook-form';
import { DateField } from '@/shared/ui/fields/date-field';
import { FormFieldMessage } from './form-field-message';
import { FormFieldProps } from './types';
import { getFormFieldState } from './utils/getFormFieldState';
import { mergeRefs } from './utils/mergeRefs';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

type Props = FormFieldProps<typeof DateField>;
export const FormDateField = ({
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    messageWrapperProps,
    isErrorVisible = true,
    isSuccessVisible,
    ref,
    ...props
}: Props) => {
    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({
                field: { ref: fieldRef, ...field },
                fieldState: { error, isDirty, isTouched, invalid },
            }) => {
                const state = getFormFieldState({
                    invalid,
                    isDirty,
                    isTouched,
                    isErrorVisible,
                    isSuccessVisible,
                });

                return (
                    <>
                        <DateField
                            ref={mergeRefs([fieldRef, ref])}
                            state={state}
                            {...parseRulesForInputAttributes(rules)}
                            {...field}
                            {...props}
                        />
                        <FormFieldMessage
                            state={state}
                            error={error}
                            messageWrapperProps={messageWrapperProps}
                        />
                    </>
                );
            }}
        />
    );
};
